import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Helmet } from 'react-helmet';
import { Button } from '@blueprintjs/core';
import Sticky from 'react-stickynode';
import * as DataList from 'components/DataList';
import SearchBars from 'components/SearchBars';
import SettingsPage from 'components/SettingsPage';
import ProductsServicesTable, {
  PRICEBOOK_COLUMNS, PRICEBOOK_CARDS, PRICEBOOK_MIN_TABLE_WIDTH,
} from 'components/Tables/ProductsServices';
import ProductServiceModal from 'components/ProductsServices/ProductServiceModal';

// Settings > Pricebook (/products_services): the labor and materials you
// charge for, searchable by name.
@inject('productServiceStore') @observer
class ProductsServicesIndexPage extends Component {
  @observable isProductServiceDialogVisible = false;
  @observable itemType = 'Labor';

  componentDidMount() {
    this.props.productServiceStore.loadProductsServices();
  }

  openAdd = () => {
    this.isProductServiceDialogVisible = true;
  };

  render() {
    const { productServiceStore } = this.props;
    const { isLoading, isError, objects } = productServiceStore.productsServices;
    let content;
    if (isLoading) {
      content = <DataList.Loading columns={PRICEBOOK_COLUMNS} cards={PRICEBOOK_CARDS} minTableWidth={PRICEBOOK_MIN_TABLE_WIDTH} noun="items" />;
    } else if (isError) {
      content = <DataList.LoadError noun="items" onRetry={() => productServiceStore.loadProductsServices()} />;
    } else if (objects) {
      content = <ProductsServicesTable onAdd={this.openAdd} />;
    }
    return (
      <React.Fragment>
        <Helmet>
          <title>Pricebook | FieldNexus</title>
        </Helmet>
        <SettingsPage
          title="Pricebook"
          description="The labor and materials you charge for, ready to add to estimates, work orders and invoices."
          actions={<Button className="sp-button sp-button--primary" icon="add" text="Add item" onClick={this.openAdd} />}
        >
          <Sticky enabled={true} top={0} innerZ={9} className="sticky-mobile">
            <SearchBars.ProductService />
          </Sticky>
          {content}
        </SettingsPage>
        <ProductServiceModal
          isOpen={this.isProductServiceDialogVisible}
          title="Add Product/Service"
          edit={false}
          onClose={() => { this.isProductServiceDialogVisible = false; }}
          onSuccess={() => { this.isProductServiceDialogVisible = false; }}
          onChangeItemTypeSelector={(event) => { this.itemType = event.target.value; }}
          itemType={this.itemType}
          showItemTypeSelector={true}
        />
      </React.Fragment>
    );
  }
}

export default ProductsServicesIndexPage;
